const $doc = $(document);

$doc.on('click', '.tabs__nav a', function(e) {
  e.preventDefault();
  var link = $(this).attr('href');
  var $linkParent = $(this).parent();
  var $tab = $(link);
  var activeClass = 'is-current';

  $tab
    .add($linkParent)
    .addClass(activeClass)
    .siblings()
    .removeClass(activeClass);
});
